import { Platform } from 'quasar'
import { boot } from 'quasar/wrappers'
import { PushNotifications } from '@capacitor/push-notifications'

export default boot(({ app, store, router }) => {
	if (!Platform.is.capacitor) return

	PushNotifications.addListener('registration', (token) => {
		store.dispatch('common/SET_DEVICE_TOKEN', [token.value])
	})

	PushNotifications.addListener('registrationError', (error) => {
		console.error('Push registration error:', error)
	})

	PushNotifications.addListener('pushNotificationReceived', (notification) => {
		// Notificação recebida com o app em foreground
	})

	PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
		const messageId = notification.notification.data?.message_id

		if (messageId) {
			store.dispatch('notifications/SET_MESSAGE_ID', [parseInt(messageId)])

			if (router.currentRoute.value.name !== 'profile') {
				router.push({ name: 'profile', query: { tab: 'inbox' } })
			} else {
				app.config.globalProperties.$mitt.emit('showMessage', parseInt(messageId))
			}
		}
	})

	PushNotifications.checkPermissions().then((result) => {
		if (result.receive === 'granted') {
			PushNotifications.register()
		} else if (result.receive === 'prompt' || result.receive === 'prompt-with-rationale') {
			PushNotifications.requestPermissions().then((requestResult) => {
				if (requestResult.receive === 'granted') PushNotifications.register()
			})
		}
	})
})
